(function () {
  function sortGrid(grid, onlyWhenBestSelling) {
    if (onlyWhenBestSelling) {
      const params = new URLSearchParams(window.location.search);
      if (params.get('sort_by') !== 'best-selling') return;
    }

    const items = Array.from(grid.querySelectorAll(':scope > li'));
    const withSold = items.filter(el => el.hasAttribute('data-units-sold'));
    const withoutSold = items.filter(el => !el.hasAttribute('data-units-sold'));

    withSold.sort((a, b) => (parseInt(b.dataset.unitsSold, 10) || 0) - (parseInt(a.dataset.unitsSold, 10) || 0));

    const fragment = document.createDocumentFragment();
    withSold.forEach(el => fragment.appendChild(el));
    withoutSold.forEach(el => fragment.appendChild(el));
    grid.appendChild(fragment);
  }

  function init() {
    // Collection grid — only sort when sort_by=best-selling
    const productGrid = document.getElementById('product-grid');
    if (productGrid) {
      sortGrid(productGrid, true);

      // Re-sort after AJAX filter/sort updates
      const container = document.getElementById('ProductGridContainer');
      if (container) {
        let debounce;
        new MutationObserver(() => {
          clearTimeout(debounce);
          debounce = setTimeout(() => {
            const grid = document.getElementById('product-grid');
            if (grid) sortGrid(grid, true);
          }, 80);
        }).observe(container, { childList: true, subtree: true });
      }
    }

    // Featured-collection grids — always sort (no URL check)
    document.querySelectorAll('[data-variant-sort-grid]').forEach(grid => {
      sortGrid(grid, false);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
